import * as React from 'react';
import Avatar from '@mui/joy/Avatar';
import Chip from '@mui/joy/Chip';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import ButtonGroup from '@mui/joy/ButtonGroup';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import CardOverflow from '@mui/joy/CardOverflow';
import CardActions from '@mui/joy/CardActions';
import IconButton from '@mui/joy/IconButton';
import Typography from '@mui/joy/Typography';
import SvgIcon from '@mui/joy/SvgIcon';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import Tooltip from '@mui/joy/Tooltip';
import CardWidget from './layouts/CardWidget';
import WidgetButtons from './WidgetButtons';

export default function ErrorLoadingWidget(props) {
    return <CardWidget {...props}>
        <em>There was an error loading this widget.</em>
        {props?.message && (<><br/><em>{props.message}</em></>)}
    </CardWidget>
}

function ErrorLoadingWidget1(props) {
  return (
    <Card
      sx={{
        width: '100%',
        height: '100%',
        boxShadow: 'md',
        gap: 0,
      }}
    >
    <CardOverflow sx={{ bgcolor: 'background.level1' }}>
        <CardActions>
            <Typography sx={{flex: 1}}>{props.title}</Typography>
            <WidgetButtons
              widget={props.widget}
              updateWidget={props.updateWidget}
              isEditing={props.isEditing}
              onEdit={props.onEdit}
              onRemove={props.onRemove}
            />
        </CardActions>
      </CardOverflow>
      <CardOverflow sx={{ overflowY: 'auto', scrollbarWidth: 'thin' }}>
        <CardContent sx={{ alignItems: 'center', textAlign: 'center',  }}>
          {props.children}
          {props.type}
          {JSON.stringify(props.options)}
        </CardContent>
      </CardOverflow>
    </Card>
  );
}
